<template>
  <div class="ver-container">
    <div v-if="showClose" class="ver-container-close" @click="close"><yd-icon name="error-outline"></yd-icon></div>
    <yd-slider autoplay="0" style="height:100%;" :show-pagination="true" :loop="false" :callback="loopP">
      <yd-slider-item v-for="(img,index) in list" :key="index">
          <div class="ver-container-item" :style="{backgroundImage:'url('+$cdnPath.img + img +')'}" @click="doOpen(index)"></div>
      </yd-slider-item>
    </yd-slider>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      showClose: false,
    };
  },
  mounted() {
    this.$dialog.loading.open('加载中');
    let count = this.list.length;
    for (let i=0; i<this.list.length; i++) {
        let img = new Image();
        img.src = this.$cdnPath.img + this.list[i];
        img.onload = ()=>{
            count --;
            if (count == 0) {
                this.$dialog.loading.close();
            }
        };
    }
  },
  created() {
    this.$yymd.removeHeader();
    let list = [], title = '版本';
    console.log(this.$route.params.id);
    if (this.$route.params.id === '2') {
      list = [
          'h5/us/ver/2/1.jpg',
          'h5/us/ver/2/2.jpg',
          'h5/us/ver/2/3.jpg',
          'h5/us/ver/2/4.jpg',
      ];
      title = 'Ver 2周年';
    } else if (this.$route.params.id === '1') {
      list = [
          'h5/us/ver/1/1.jpg',
          'h5/us/ver/1/2.jpg',
          'h5/us/ver/1/3.jpg',
          'h5/us/ver/1/4.jpg',
          'h5/us/ver/1/5.jpg',
          'h5/us/ver/1/6.jpg',
      ];
      title = 'Ver 1.0';
    } else if (this.$route.params.id === 'old') {
      list = [
          'h5/us/ver/old/2.jpg',
          'h5/us/ver/old/3.jpg',
          'h5/us/ver/old/4.jpg',
          'h5/us/ver/old/5.jpg',
          'h5/us/ver/old/6.jpg',
          'h5/us/ver/old/7.jpg',
      ];
      title = 'Ver Old';
    } else if (this.$route.params.id === 'ori') {
      list = [
          'h5/us/ver/ori/1.jpg',
          'h5/us/ver/ori/2.jpg',
          'h5/us/ver/ori/3.jpg',
          'h5/us/ver/ori/4.jpg',
          'h5/us/ver/ori/5.jpg',
          'h5/us/ver/ori/6.jpg',
          'h5/us/ver/ori/7.jpg',
          'h5/us/ver/ori/8.jpg',
          'h5/us/ver/ori/9.jpg',
      ];
      title = 'Ver Original';
    }
    this.list = list;
    document.title = title;
  },
  methods: {
      loopP(i){
          if (i == this.list.length - 1) {
              this.showClose = true;
          } else {
              this.showClose = false;
          }
      },
      close (){
          this.$yymd.close();
      },
      doOpen(index){
          this.showClose = !this.showClose;
        //   if (index + 1 == this.list.length) {
              
        //   }
      }
  }
};
</script>
<style lang="less" scoped>
.ver-container {
    position:relative;
    width:100%;
    height:100%;
    &-item {
        // border:5px solid red;
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% auto;
    }
    &-close {
        position:fixed; z-index: 10000;
        color:#fff;
        top:1rem; right:.2rem;
        text-shadow:  0px 0px 1px #999;
    }
}
</style>